<qaroni-query-param-select-object-filter
  class="w-full"
  [firstOption]="firstOption()"
  [options]="$employees()"
  [label]="label()"
  textKey="fullName"
  valueKey="employeeId"
  [showTextFilter]="true"
  [queryParamName]="queryParamName()"
  [multiple]="multiple()"
  (queryParamsChange)="onQueryParamsChange($event)" />
